export default __webpack_public_path__ + "static/media/filling_8.578b715a.webp";